import { render, staticRenderFns } from "./discountSvg.vue?vue&type=template&id=08c468c8&"
import script from "./discountSvg.vue?vue&type=script&lang=js&"
export * from "./discountSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c468c8')) {
      api.createRecord('08c468c8', component.options)
    } else {
      api.reload('08c468c8', component.options)
    }
    module.hot.accept("./discountSvg.vue?vue&type=template&id=08c468c8&", function () {
      api.rerender('08c468c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/paymentPlans/components/discountSvg.vue"
export default component.exports